import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { CurvaAbcVendaPerspectivaContentModule } from '../content';

import { CurvaAbcVendaPerspectivaNavComponent } from './curva-abc-venda-perspectiva-nav.component';

@NgModule({
    imports: [
        SharedModule,
        CurvaAbcVendaPerspectivaContentModule
    ],
    declarations: [
        CurvaAbcVendaPerspectivaNavComponent
    ],
    exports: [
        CurvaAbcVendaPerspectivaNavComponent
    ]
})
export class CurvaAbcVendaPerspectivaNavModule { }
